<template>
  <PageSeoData :title="pageTitle" />
  <section class="section section--with-padding documents">
    <h2>
      {{ pageTitle }}
    </h2>
    <ScrollSlider
      v-if="filteredQueries.length"
      :items="filteredQueries"
      class="documents__scroll-slider">
      <template #scroll-slider-item="{ item }">
        <p>{{ item.item?.title }}</p>
        <div>
          <LocLink :to="item.item?.path">
            {{ $t("Open document") }}
          </LocLink>
          <BaseIcon icon="arrow" />
        </div>
      </template>
    </ScrollSlider>
  </section>
</template>

<script setup lang="ts">
import ScrollSlider from "~/components/slider/ScrollSlider.vue";
import LocLink from "~/components/lang/LocLink.vue";
import BaseIcon from "~/components/icons/BaseIcon.vue";
import getDocumentsData from "~/utils/getDocumentsData";
import PageSeoData from "~/components/pageSeoData/PageSeoData.vue";
const { locale } = useI18n();

const { DOCUMENTS_DATA } = getDocumentsData();

const props = defineProps<{ page: string }>();
const pageTitle = computed(() => DOCUMENTS_DATA[props.page as string].title);

if (
  !Object.keys(DOCUMENTS_DATA).some(
    (documentData) => props.page === documentData
  )
) {
  throw createError({
    statusCode: 404,
    fatal: true,
  });
}

const { data: queries } = await useAsyncData(
  `document-list-${locale.value}-${props.page}`,
  () => Promise.all(
    DOCUMENTS_DATA[props.page].items.map((category) =>
      queryCollection("content")
        .where("path", "LIKE", `/${locale.value}/${category}/%`)
        .order("stem", "DESC")
        .first()
    )
  ),
  { watch: [locale, () => props.page] }
);

const filteredQueries = computed(() => queries.value?.filter(query => !!query) ?? []);
</script>
